import { useNavigate, useLocation, useParams } from 'react-router-dom'

export function useRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()

  const query = new URLSearchParams(location.search)
  const queryObject = Object.fromEntries(query.entries())

  return {
    push: navigate,
    replace: (path, state) => navigate(path, { replace: true, state }),
    pathname: location.pathname,
    query: params,
    queryParams: queryObject,
    asPath: location.pathname + location.search,
    location,
    refresh: () => navigate(0),
  }
}
